import type { PrimitiveType } from '#layers/data-model/public';
import { resolveFieldParser } from '#layers/data-model/public';

const DATE_TIME_WITH_TIMEZONE = { name: 'dateTimeWithTimezone' } satisfies PrimitiveType;
const baseDateTimeWithTimezoneParser = resolveFieldParser('dateTimeWithTimezone')!;

const dateTimeWithTimezoneParser = {
	parse: (value: unknown): any => baseDateTimeWithTimezoneParser.parse?.(value),
	serialize: (value: any) => baseDateTimeWithTimezoneParser.serialize?.(value),
};

export function defineSystemDateTimeFields<T extends string>(fieldNames: readonly T[]) {
	return Object.fromEntries(
		fieldNames.map((fieldName) => [fieldName, dateTimeWithTimezoneParser]),
	) as Record<T, typeof dateTimeWithTimezoneParser>;
}

export function defineSystemDateTimeFieldTypes<T extends string>(fieldNames: readonly T[]) {
	return Object.fromEntries(
		fieldNames.map((fieldName) => [fieldName, DATE_TIME_WITH_TIMEZONE]),
	) as Record<T, typeof DATE_TIME_WITH_TIMEZONE>;
}
